import { DataService } from '@services/data/data.service';
import { Injectable } from '@angular/core';
import { DocumentTemplate } from '@shared/models/documenttemplate/document.template';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DocumenttemplatesService extends DataService {

    override get url(): string {
        const base = this.configService.config?.apiBaseUrl ?? '';
        return `${base}documenttemplates`;
    }

    getDocumentTemplates(): Observable<DocumentTemplate[]> {
        return this.getAll<DocumentTemplate[]>();
    }
}

